import apiClient from './client'

/**
 * Obtiene thumbnails de múltiples eventos en una sola llamada
 */
export const getThumbnailsBatch = async (idEventos) => {
  const response = await apiClient.post('/api/radar/thumbnails', {
    idEventos,
  })
  // La respuesta tiene estructura: { code, payload: { Thumbnails: [...] }, message }
  return response.data
}

/**
 * Obtiene las miniaturas (200px) de las imágenes de un evento
 */
export const getImagenesEvento = async (idEvento) => {
  const response = await apiClient.get(`/api/radar/eventos/${idEvento}/imagenes`)
  // La respuesta tiene estructura: { code, payload: [...], message }
  return response.data
}

/**
 * Obtiene una imagen completa por su ID
 */
export const getImagenCompleta = async (idEventoImagen) => {
  const response = await apiClient.get(`/api/radar/imagenes/${idEventoImagen}`)
  // La respuesta tiene estructura: { code, payload: { idEventoImagen, nombreArchivo, ..., imagenBase64 }, message }
  return response.data
}
